import { ChevronDown, Building2, LoaderCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "../ui/sidebar";
import { Badge } from "../ui/badge";
import { useOrgContext } from "./OrgContext";

export function OrgSwitcher() {
  const { orgs, currentOrg, isLoading, isSwitching, switchOrg } =
    useOrgContext();
  const activeOrgs = orgs.filter(
    (org) => org.membership.status === "active"
  );
  const label = currentOrg?.name ?? "Select workspace";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton tooltip="Switch workspace" aria-label={isSwitching ? "Switching workspace…" : `Switch workspace: ${label}`} disabled={isSwitching} aria-busy={isSwitching}>
              {isSwitching ? <LoaderCircle aria-hidden="true" className="animate-spin motion-reduce:animate-none" /> : <Building2 />}
              <span className="group-data-[collapsible=icon]:hidden">{isSwitching ? "Switching workspace…" : label}</span>
              <ChevronDown aria-hidden="true" className="ml-auto group-data-[collapsible=icon]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="bottom" align="start" className="w-64">
            <DropdownMenuLabel>Workspaces</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {isLoading ? (
              <DropdownMenuItem disabled>Loading workspaces...</DropdownMenuItem>
            ) : activeOrgs.length === 0 ? (
              <DropdownMenuItem disabled>No active workspaces</DropdownMenuItem>
            ) : (
              activeOrgs.map((org) => {
                const isActive = org.org.id === currentOrg?.id;
                return (
                  <DropdownMenuItem
                    key={org.org.id}
                    disabled={isActive || isSwitching}
                    onClick={() => void switchOrg(org.org.id).catch(() => undefined)}
                  >
                    <div className="flex w-full items-center justify-between gap-2">
                      <span className="truncate">{org.org.name}</span>
                      {isActive ? (
                        <Badge variant="secondary" className="uppercase">
                          Active
                        </Badge>
                      ) : null}
                    </div>
                  </DropdownMenuItem>
                );
              })
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
